import { Component,OnInit,AfterViewInit,HostListener,ElementRef,OnDestroy,ChangeDetectionStrategy } from "@angular/core";
import { takeWhile } from "rxjs/operators";
import { interval } from "rxjs";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DecimalPipe } from "@angular/common";

import {
    FvmsCommonService
    ,FvmsApiAuthService
    ,FvmsApiDtgCarService
    ,FvmsMainCarService
    ,FvmsMapApiProvidor
} from "src/app/shared/service";
import {
    FilterCarStatus
    ,FilterCarStatusTimeLimit
    ,FilterCarTeam
    ,FilterCarSearch
    ,FilterDist
    ,FilterSecToTime
    ,FilterCarStatusTrans
} from "src/app/shared/filter";
import { DtgCarLastTripListComponent } from "src/app/dtg/car/last/trip/list/dtg.car.last.trip.list.component";
import * as lodash from "lodash";

@Component({
    selector: "dtg-car-last-list-map"
    ,templateUrl: "./dtg.car.last.list.map.component.html"
    ,styleUrls: ["./dtg.car.last.list.map.component.scss"]
    ,providers: [
        FilterCarStatus
        ,FilterCarStatusTimeLimit
        ,FilterCarTeam
        ,FilterCarSearch
        ,FilterDist
        ,FilterSecToTime
        ,FilterCarStatusTrans
        ,DecimalPipe
    ]
})
export class DtgCarLastListMapComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    currentUserInfo:any;
    companyInfo:any;
    mapService:any;
    mapCarInfo:any[];
    mapCarInfoFiltered:any[];
    mapClusterGeoHash:any[];
    mapClusterGeoHashFiltered:any[];
    eventChangeZoom:any;
    // selectedCar:any;
    isMapAutoReload:boolean = false;
    isShowTraffic:boolean = false;
    timeMapAutoReloadTerm:number = (1000 * 60 * 3);//자동갱신 3분마다
    timeMapAutoReload:number = this.timeMapAutoReloadTerm;
    renderChange:boolean = false

    constructor(
        private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsCommonService: FvmsCommonService
        ,private fvmsMapApiProvidor:FvmsMapApiProvidor
        ,private fvmsMainCarService:FvmsMainCarService
        ,private fvmsApiDtgCarService:FvmsApiDtgCarService
        ,private filterCarStatusTrans:FilterCarStatusTrans
        ,private decimalPipe:DecimalPipe
        ,private filterDist:FilterDist
        ,private elementRef:ElementRef
        ,private modalService: NgbModal
    ){}

    ngOnInit(){
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.mapService = this.fvmsMapApiProvidor.getMapApiService();
        this.mapService.initMapContainer("map-container-01");
        this.mapService.addControlViewMode();
        this.mapService.addControlZoom();
        this.mapService.addControlCopyright();
        this.mapService.initLatLngBounds();
        this.mapService.initGeocoder();
        this.mapService.initMarkerClusterer();
        let self = this;
        this.fvmsMainCarService.subjCarFromSidebar
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(evtObj => {
                this.renderChange = true
                this.fvmsCommonService.setIsLoading(true);
                console.log("evtObj",evtObj);
                this.clearMapZoomEvent()
                this.hideMarkerCar();
                this.hideCluster();
                const isReload = (evtObj.evtCode === "sidebar.auto.reload.car")?true:false
                switch(evtObj.evtCode){
                    case "sidebar.init.car":
                    case "sidebar.auto.reload.car":
                        this.mapClusterGeoHash = [];
                        this.mapClusterGeoHashFiltered = [];
                        this.mapCarInfo = evtObj.listCar;
                        this.mapCarInfoFiltered = evtObj.listCarFilter;
                        this.getListClusterGeoHash().then(() => {
                            this.initLatLngBoundGeoHash(isReload).then(() => {
                                if(this.currentUserInfo.showMapCluster === true) {
                                    this.createCluster();
                                    this.showCluster();
                                }
                                this.createMarkerCar();
                                this.showMarkerCar();
                                this.mapZoomEvent()
                            }).finally(()=>{
                                this.fvmsCommonService.setIsLoading(false);
                            })
                        }).finally(()=>{
                            this.fvmsCommonService.setIsLoading(false);
                        })
                        break;
                    case "sidebar.select.car.team":
                    case "sidebar.select.car.status":
                    case "sidebar.unselect.car.team":
                    case "sidebar.select.car.item":
                    case "sidebar.unselect.car.item":
                    case "sidebar.search.car":
                        this.mapCarInfo = evtObj.listCar;
                        this.mapCarInfoFiltered = evtObj.listCarFilter;
                        this.mapClusterGeoHashFiltered = [];
                            if(this.currentUserInfo.showMapCluster === true) {
                                this.createMapClusterGeoHashFiltered();
                                this.calcClusterCar();
                            }
                            this.initLatLngBoundCar().then(() => {
                                if(this.currentUserInfo.showMapCluster === true) {
                                    this.createCluster();
                                    this.showCluster();
                                }
                                this.createMarkerCar();
                                this.showMarkerCar();
                                this.mapZoomEvent()
                            }).finally(()=>{
                                this.fvmsCommonService.setIsLoading(false);
                            })
                        break;
                    // case "sidebar.unselect.car.status":
                    // case "sidebar.auto.reload.car":
                    default:
                        // tmpListCar = evtObj.listCar;
                        break;
                }
                setTimeout(() => {
                    this.renderChange = false
                }, 1000);
                this.mapService.relayout();
                this.fvmsCommonService.setIsLoading(false);
            },err => {
                console.error("DtgCarExtLastMapComponent","subjectListCar",err);
            }
            ,() => {
                this.mapService.relayout();
                this.fvmsCommonService.setIsLoading(false);
            });

            this.fvmsCommonService.subscribeToggleSideMenu()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(status => {
                const aside = $('#seda_car_list');
                if(!aside.hasClass('mini-sidebar')) {
                    aside.addClass('mini-sidebar');
                }else{
                    aside.removeClass('mini-sidebar');
                }
            });

            this.fvmsApiAuthService.getCurrentUserInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(currentUserInfo => {
                this.currentUserInfo = currentUserInfo;
            });
    }

    ngAfterViewInit() {
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        if(this.mapService){
            this.mapService.relayout();
        }
    }

    mapZoomEvent(){
        this.clearMapZoomEvent()
        this.mapService.relayout();
        this.eventChangeZoom = this.changeZoomLevel.bind(this);
        this.mapService.addMapEvent("zoom_changed",this.eventChangeZoom);
    }

    clearMapZoomEvent() {
        if(this.eventChangeZoom){
            this.mapService.removeMapEvent("zoom_changed",this.eventChangeZoom);
        }
    }

    changeZoomLevel(){
        let zoomLevel = this.mapService.getZoomLevel();
        let limitHash = this.mapService.getGeoHashLimit(zoomLevel);
        console.log("changeZoomLevel",zoomLevel,"limitHash",limitHash);
        // zoom 이 변경될때는 boundary를 초기화 할 필요 없다
        this.hideMarkerCar();
        this.hideCluster();
        if(this.currentUserInfo.showMapCluster === true) {
            this.createCluster();
            this.showCluster();
        }
        this.createMarkerCar();
        this.showMarkerCar();
    }

    // 회사의 차량 목록을 map 으로 변환
    // 선택된 그룹의 차량 목록을 map 으로 변환
    convListCarToMap(listCarFrom:any[],mapCarTo:any[]){
        let promise = new Promise<void>((resolve,reject) => {
            if(listCarFrom){
                let sizeList = listCarFrom.length;
                for(let a=0;a<sizeList;a++){
                    let itemCar = listCarFrom[a];
                    mapCarTo[itemCar.dtgUnitId] = itemCar;
                }
            }
            // console.log("this.mapCarInfo",this.mapCarInfo);
            resolve();
        });
        return promise;
    }

    // 클러스터용 geohash map 을 생성
    getListClusterGeoHash(){
        let promise = new Promise<void>((resolve,reject) => {
            if(this.mapCarInfo){
                // 단말들의 geohash 값을 list로 만들어서 서버로 보낸다
                // geohash 3자리 ~ 6자리 까지 분리하고
                // 각 geohash 의 lat,lng 을 받아온다
                const listGeoHash = lodash.chain(this.mapCarInfo).groupBy('dtgGpsGeoHash').value();
                let paramGeoHash = Object.keys(listGeoHash);
                this.fvmsApiDtgCarService.getListGeoHash(paramGeoHash)
                    .pipe(takeWhile(() => this.isContinue))
                    .subscribe(response => {
                        if(response.resultStatus === "ok"){
                            if(response.resultValue){
                                let listGeoHashNew = response.resultValue;
                                listGeoHashNew.map(itemGeoHash =>{
                                    let keyGeoHash = itemGeoHash.geoHash;
                                    itemGeoHash["listCarInfo"] = [];
                                    const sizeKey = keyGeoHash.length
                                    this.mapCarInfoFiltered.filter(item => item.dtgGpsGeoHash && item.dtgGpsGeoHash.substr(0,sizeKey) === keyGeoHash)
                                    .map(itemCarInfo => {
                                        itemGeoHash.listCarInfo.push(itemCarInfo);
                                    })
                                    this.mapClusterGeoHash[keyGeoHash] = itemGeoHash;
                                })
                                this.mapClusterGeoHashFiltered = Object.assign([], this.mapClusterGeoHash)
                            }
                        }
                    },err => {
                        console.error("getListClusterGeoHash",err);
                    }
                    ,() => {
                        resolve();
                    });
            }else{
                resolve();
            }
        });
        return promise;
    }

    // 지오해시 목록을 이용해서 전체 boundary 를 계산
    // 처음 진입시 모든 차량으로 계산하면 느리니까
    // 갯수가 적은 해시값으로
    initLatLngBoundGeoHash(reload:boolean = false){
        let promise = new Promise<void>((resolve,reject) => {
            if(!this.mapClusterGeoHashFiltered){
                return;
            }
            let listLatLng = [];
            for(let geohash in this.mapClusterGeoHashFiltered){
                // 전체 지도용은 3자리
                if(geohash.length !== 3){
                    continue;
                }
                let itemGeoHash = this.mapClusterGeoHashFiltered[geohash];
                let latLngCluster = this.mapService.createLatLng(itemGeoHash.lat,itemGeoHash.lng);
                itemGeoHash["latLng"] = latLngCluster;
                let latLng = itemGeoHash.latLng;
                if(latLng) {
                    listLatLng.push(latLng);
                }
            }
            if(!reload) {
                this.mapService.initLatLngBounds();
                if(listLatLng && listLatLng.length > 0){
                    this.mapService.appendLatLngBoundsFromList(listLatLng);
                    if(listLatLng.length === 1){
                        this.mapService.setZoomLevel(12);
                    }
                }
            }
            resolve();
        });
        return promise;
    }

    // 차량 목록을 이용해서 전체 boundary 를 계산
    initLatLngBoundCar(){
        let promise = new Promise<void>((resolve,reject) => {
            if(!this.mapCarInfoFiltered){
                return;
            }
            let listLatLng = [];
            this.mapCarInfoFiltered.map( itemCarInfo => {
                // 원본에서 찾아본다
                if(itemCarInfo.hasOwnProperty("latLng") === false){
                    let lat = itemCarInfo.dtgGpsLat;
                    let lng = itemCarInfo.dtgGpsLng;
                    if(this.mapService.checkLatLng(lat,lng) === false){
                        return;
                    }
                    let latLngCar = this.mapService.createLatLng(lat,lng);
                    itemCarInfo["latLng"] = latLngCar;
                }
                if(itemCarInfo.latLng){
                    listLatLng.push(itemCarInfo.latLng);
                }
            })
            this.mapService.initLatLngBounds();
            if(listLatLng && listLatLng.length > 0){
                this.mapService.appendLatLngBoundsFromList(listLatLng);
            }
            resolve();
        });
        return promise;
    }

    createMapClusterGeoHashFiltered(){
        if(!this.mapCarInfoFiltered){
            return;
        }
        if(!this.mapClusterGeoHash){
            return;
        }
        this.mapCarInfoFiltered.map(itemCarFiltered => {
            let itemCarGeoHash = itemCarFiltered.dtgGpsGeoHash;
            if(!itemCarGeoHash){
                return
            }
            for(let a=6;a>2;a--){
                let geohashPre = itemCarGeoHash.substr(0,a);
                this.mapClusterGeoHashFiltered[geohashPre] = this.mapClusterGeoHash[geohashPre];
            }
        })
    }

    // geohash key 에 해당하는 unitId 를 할당
    calcClusterCar(){
        if(!this.mapClusterGeoHashFiltered){
            return;
        }
        if(!this.mapCarInfoFiltered){
            return;
        }
        for(let keyGeoHash in this.mapClusterGeoHashFiltered){
            let itemGeoHash = this.mapClusterGeoHashFiltered[keyGeoHash];
            itemGeoHash["listCarInfo"] = [];
            delete itemGeoHash.marker
            delete itemGeoHash.latLng
            let sizeKey = keyGeoHash.length;
            this.mapCarInfoFiltered.filter(item => item.dtgGpsGeoHash && item.dtgGpsGeoHash.substr(0,sizeKey) === keyGeoHash)
            .map(itemCarInfo => {
                itemGeoHash.listCarInfo.push(itemCarInfo);
            })
        }
        // console.log("calcClusterCar",this.mapClusterGeoHashFiltered);
    }

    // 클러스터를 마커로 생성
    createCluster(){
        if(!this.mapClusterGeoHashFiltered){
            return;
        }
        let zoomLevel = this.mapService.getZoomLevel();
        let limitHash = this.mapService.getGeoHashLimit(zoomLevel);
        if(limitHash > 0){
            for(let geohash in this.mapClusterGeoHashFiltered){
                if(geohash.length === limitHash){
                    let itemGeoHash = this.mapClusterGeoHashFiltered[geohash];
                    if(!itemGeoHash.listCarInfo || itemGeoHash.listCarInfo.length === 0){
                        continue;
                    }
                    if(itemGeoHash.listCarInfo.length === 1){
                        // 클러스터에 차량이 1대만 있으면 차량 마커를 출력
                        let carInfo = itemGeoHash.listCarInfo[0];
                        this.createMarkerCarOne(carInfo);
                    }else{
                        // geohash 의 좌표값은 변화가 없으므로 원본에서 가져온다
                        let itemGeoHashOrigin = this.mapClusterGeoHash[geohash];
                        if(itemGeoHashOrigin.hasOwnProperty("latLng") === false){
                            let latLngCluster = this.mapService.createLatLng(itemGeoHash.lat,itemGeoHash.lng);
                            itemGeoHashOrigin["latLng"] = latLngCluster;
                        }
                        itemGeoHash["latLng"] = itemGeoHashOrigin.latLng;
                        // 마커는 필터링된 차량수가 달라지므로 매번 새롭게 생성
                        let imgWidth = 60;
                        let imgHeight = 60;
                        let cntListUnitId = itemGeoHash.listCarInfo.length || 0;
                        let imgSrc = this.mapService.getSvgImgTagCluster(cntListUnitId,imgWidth,imgHeight);
                        let imgOption = {
                            imgSrc: imgSrc
                            ,imgWidth:imgWidth
                            ,imgHeight:imgHeight
                            ,offsetX:30
                            ,offsetY:30
                        };
                        let latLng = itemGeoHash.latLng;
                        let marker = this.mapService.createMarkerFromLatLng(
                            latLng
                            ,geohash
                            ,imgOption
                        );
                        itemGeoHash["marker"] = marker;
                        if(marker){
                            let clusterClickEvent = () => {
                                let lat = undefined
                                let lng = undefined
                                let lv = this.mapService.getZoomLevel();
                                const pos = marker.getPosition();
                                lat = pos.getLat();
                                lng = pos.getLng();
                                lv-=2;
                                if(lv<3) lv = 3;
                                if(lat && lng) {
                                    this.mapService.setCenter(lat, lng);
                                    this.mapService.setZoomLevel(lv);
                                }
                            }
                            this.mapService.addMarkerEvent(marker,"click", clusterClickEvent);
                        }
                    }
                }
            }
        }
    }

    // 모든 크러스터 마커를 닫는다
    hideCluster(){
        if(!this.mapClusterGeoHashFiltered){
            return;
        }
        for(let geohash in this.mapClusterGeoHashFiltered){
            let itemGeoHash = this.mapClusterGeoHashFiltered[geohash];
            let marker = itemGeoHash.marker;
            if(marker){
                this.mapService.hideMarker(marker);
            }
        }
        this.mapService.initLatLngBounds();
    }

    // 클러스터를 지도에 출력
    showCluster(){
        if(!this.mapClusterGeoHashFiltered){
            return;
        }
        let zoomLevel = this.mapService.getZoomLevel();
        let limitHash = this.mapService.getGeoHashLimit(zoomLevel);
        if(limitHash > 0){
            for(let geohash in this.mapClusterGeoHashFiltered){
                if(geohash.length === limitHash){
                    let itemGeoHash = this.mapClusterGeoHashFiltered[geohash];
                    let marker = itemGeoHash.marker;
                    if(marker){
                        this.mapService.showMarker(marker);
                    }
                }
            }
        }
    }

    // 차량 마커를 생성
    createMarkerCar(){
        let zoomLevel = this.mapService.getZoomLevel();
        let limitHash = this.mapService.getGeoHashLimit(zoomLevel);
        if(limitHash === 0){
            this.mapCarInfoFiltered.map(itemCarInfo =>{
                if(itemCarInfo.hasOwnProperty("marker") === false){
                    this.createMarkerCarOne(itemCarInfo);
                }
            })
        }
    }

    createMarkerCarOne(itemCarInfo){
        if(!this.mapCarInfo || !itemCarInfo){
            return;
        }
        // 원본에서 marker 를 가져온다
        if(itemCarInfo.hasOwnProperty("marker") === true){
            return;
        }
        let latLng = undefined
        if(!itemCarInfo.hasOwnProperty("latLng") || itemCarInfo.latLng === null){
            latLng = this.mapService.createLatLng(itemCarInfo.dtgGpsLat,itemCarInfo.dtgGpsLng);
            itemCarInfo["latLng"] = latLng;
        }else{
            latLng = itemCarInfo.latLng;
        }
        if(itemCarInfo.latLng){
            let imgWidth = 100;
            let imgHeight = 114;
            let carStatus = this.filterCarStatusTrans.transform(itemCarInfo);
            let sampleImgSrc = this.mapService.getSvgImgTagCarWithNo(
                itemCarInfo.dtgCarNo
                ,itemCarInfo.dtgUnitId
                ,carStatus
                ,itemCarInfo.dtgGpsDirection
                ,imgWidth
                ,imgHeight
            );
            let imgOption = {
                imgSrc: sampleImgSrc
                ,imgWidth:imgWidth
                ,imgHeight:imgHeight
                ,offsetX:50
                ,offsetY:60
            };

            let marker = this.mapService.createMarkerFromLatLng(
                itemCarInfo.latLng
                ,itemCarInfo
                ,imgOption
            );
            if(marker){
                itemCarInfo.marker = marker;
                let markerClickEvent = this.clickMarker.bind(this,event,itemCarInfo);
                this.mapService.addMarkerEvent(marker,"click",markerClickEvent);
                let iwContent = this.createInfoWindowContent(itemCarInfo);
                let infoWindow = this.mapService.createInfoWindowFromLatLng(latLng,iwContent);
                itemCarInfo.infoWindow = infoWindow;
            }
        }
    }

    hideInfoWindow(){
        if(!this.mapCarInfoFiltered){
            return;
        }
        this.mapCarInfoFiltered.map(itemCarInfo => {
            if(itemCarInfo.hasOwnProperty("infoWindow") === true){
                this.mapService.hideInfoWindow(itemCarInfo.infoWindow);
            }
        })
    }

    // 차량 마커를 닫는다
    hideMarkerCar(){
        if(!this.mapCarInfoFiltered){
            return;
        }
        this.mapCarInfoFiltered.map(itemCarInfo => {
            if(itemCarInfo.hasOwnProperty("infoWindow") === true){
                this.mapService.hideInfoWindow(itemCarInfo.infoWindow);
            }
            if(itemCarInfo.hasOwnProperty("marker") === true){
                this.mapService.hideMarker(itemCarInfo.marker);
            }
        })
    }

    // 차량 마커를 표시
    showMarkerCar(){
        if(!this.mapCarInfoFiltered){
            return;
        }
        let zoomLevel = this.mapService.getZoomLevel();
        let limitHash = this.mapService.getGeoHashLimit(zoomLevel);

        if(this.currentUserInfo.showMapCluster === false) {
            this.mapCarInfoFiltered.map(itemCarInfo => {
                if(itemCarInfo.hasOwnProperty("marker") === false){
                    this.createMarkerCarOne(itemCarInfo);
                }
                if(itemCarInfo.hasOwnProperty("marker") === true){
                    this.mapService.showMarker(itemCarInfo.marker);
                }
            })
            return
        }

        // 전체 출력
        if(limitHash === 0){
            this.mapCarInfoFiltered.map(itemCarInfo => {
                if(itemCarInfo.hasOwnProperty("marker") === false){
                    this.createMarkerCarOne(itemCarInfo);
                }
                if(itemCarInfo.hasOwnProperty("marker") === true){
                    this.mapService.showMarker(itemCarInfo.marker);
                }
            })
        }else{
            for(let geohash in this.mapClusterGeoHashFiltered) {
                if(geohash.length === limitHash){
                    let itemGeoHash = this.mapClusterGeoHashFiltered[geohash];
                    if(!itemGeoHash.listCarInfo || itemGeoHash.listCarInfo.length > 1){
                        // 클러스터에 2대이상 또는 없는 경우 통과
                        continue;
                    }

                    // 클러스터에 1대만 있는 경우
                    let itemCarInfo = itemGeoHash.listCarInfo[0];
                    if(itemCarInfo.hasOwnProperty("marker") === false){
                        this.createMarkerCarOne(itemCarInfo);
                    }
                    if(itemCarInfo.hasOwnProperty("marker") === true){
                        this.mapService.showMarker(itemCarInfo.marker);
                    }
                }
            }
        }
    }

    // 차량 마커를 클릭
    clickMarker(event:any,carInfo:any){

        this.hideInfoWindow();

        if(carInfo.hasOwnProperty("marker") === false){
            this.createMarkerCarOne(carInfo);
        }
        // 지도에서 마커를 클릭한게 아니라 차량 목록에서 아이템 선택시에
        // 마커를 만들지 못했다면 멈춰라
        if(carInfo.hasOwnProperty("marker") === false){
            return;
        }
        this.mapService.showMarker(carInfo.marker);

        if(carInfo.hasOwnProperty("infoWindow") === false){
            let iwContent = this.createInfoWindowContent(carInfo);
            let infoWindow = this.mapService.createInfoWindowFromLatLng(carInfo.latLng,iwContent);
            carInfo["infoWindow"] = infoWindow;
        }
        if(carInfo.hasOwnProperty("infoWindow") === true){
            this.mapService.showInfoWindow(carInfo.marker,carInfo.infoWindow);
            // 운행이력 버튼
            let driveHisBtn = this.elementRef.nativeElement.querySelector(`#btn-drive-history-${carInfo.dtgUnitId}`);
            if(driveHisBtn && !carInfo["eventHandlerClickDriveHis"]){
                // 운행이력 버튼 이벤트 추가
                let eventHandlerClickDriveHis = this.clickShowDriveHis.bind(this,event,carInfo);
                driveHisBtn.addEventListener("click",eventHandlerClickDriveHis);
                carInfo["eventHandlerClickDriveHis"] = eventHandlerClickDriveHis;
            }
        }
        let eveObj = {
            evtCode:"map.select.car.item"
            ,selectedCar:carInfo
        };
        this.fvmsMainCarService.subjCarFromMainMap.next(eveObj);
    }

    // 차량 목록에서 아이템 선택 또는 해제
    clickCarInfo(carInfo:any){
        this.hideMarkerCar();
        if(!carInfo){
            // this.hideMarkerCar();
            // this.hideCluster();
            // this.createCluster();
            // this.showCluster();
            // this.createMarkerCar();
            // this.showMarkerCar();
            return;
        }
        this.clickMarker(null,carInfo);
    }

    // 마커의 팝업 생성
    createInfoWindowContent(item){

        if( typeof item.memo === 'undefined')
          item.memo = "";

        let self = this;
        let iwContent = "";
        iwContent += `<div class="card mb-0" style="width:35vw;">`;
        iwContent += `    <div class="card-header p-2 bg-info text-light">`;
        iwContent += `        <div class="h5 card-title mb-0">`;
        iwContent += `            <i class="mdi mdi-car"></i>`;
        iwContent += `            ${item.dtgCarNo}`;
        if(item.ownYn === 'N'){
            iwContent += `            <span class="badge badge-pill badge-warning ml-2">`;
            iwContent += `                ${item.companyNm}`;
            iwContent += `            </span>`;
        }
        // iwContent += `            <span class="badge badge-pill badge-warning ml-2">`;
        // iwContent += `                ${item.dtgUnitId}`;
        // iwContent += `            </span>`;
        iwContent += `        </div>`;
        iwContent += `    </div>`;
        iwContent += `    <div class="card-body p-2">`;
        iwContent += `        <div class="row">`;
        iwContent += `            <div class="col">`;
        iwContent += `                <ul class="list-group list-group-flush">`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-checkbox-marked-outline"></i>`;
        iwContent += `                            메모`;
        iwContent += `                        </span>`;
        iwContent += `                        <span>${item.memo}</span>`;
        iwContent += `                    </li>`;
        iwContent += `                </ul>`;
        iwContent += `            </div>`;
        iwContent += `        </div>`;
        iwContent += `        <div class="row">`;
        iwContent += `            <div class="col">`;
        iwContent += `                <ul class="list-group list-group-flush">`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-map-marker"></i>`;
        iwContent += `                            ${item.dtgGpsAddr}`;
        iwContent += `                        </span>`;
        iwContent += `                        <div>`;
        // 적용안됨
        // iwContent += `                            <icon-power [dtgKeyOnYn]="${item.dtgKeyOnYn}" [dtgRegDt]="${item.dtgRegDt}"></icon-power>`;
        // iwContent += `                            <icon-gps [dtgGpsStatus]="${item.dtgGpsStatus}" class="ml-1"></icon-gps>`;
        // iwContent += `                            <icon-network [dtgRssi]="${item.dtgRssi}" class="ml-1"></icon-network>`;
        iwContent += `                            <button type="button" class="btn btn-sm btn-outline-info" id="btn-drive-history-${item.dtgUnitId}">`;
        iwContent += `                                <i class="mdi mdi-clipboard-text"></i>`;
        iwContent += `                                <span class="ml-1">운행정보</span>`;
        iwContent += `                            </button>`;
        iwContent += `                        </div>`;
        iwContent += `                    </li>`;
        iwContent += `                </ul>`;
        iwContent += `            </div>`;
        iwContent += `        </div>`;
        iwContent += `        <div class="row">`;
        iwContent += `            <div class="col">`;
        iwContent += `                <ul class="list-group list-group-flush">`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-home"></i>`;
        iwContent += `                            소속회사`;
        iwContent += `                        </span>`;
        iwContent += `                        <span>${item.companyNm}</span>`;
        iwContent += `                    </li>`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-clock"></i>`;
        iwContent += `                            수신일시`;
        iwContent += `                        </span>`;
        iwContent += `                        <span>${item.dtgRegDt}</span>`;
        iwContent += `                    </li>`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-checkbox-marked-outline"></i>`;
        iwContent += `                            일일거리`;
        iwContent += `                        </span>`;
        iwContent += `                        <span>${this.decimalPipe.transform(this.filterDist.transform(item.dtgDistDaily),'0.0-1')} km</span>`;
        iwContent += `                    </li>`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-checkbox-marked-outline"></i>`;
        iwContent += `                            누적거리`;
        iwContent += `                        </span>`;
        iwContent += `                        <span>${this.decimalPipe.transform(this.filterDist.transform(item.dtgDistAccumul),'0.0-1')} km</span>`;
        iwContent += `                    </li>`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-checkbox-marked-outline"></i>`;
        iwContent += `                            일일연료소모량`;
        iwContent += `                        </span>`;
        iwContent += `                        <span>${this.decimalPipe.transform(this.filterDist.transform(item.dtgOilUseDaily),'0.0-1')} L</span>`;
        iwContent += `                    </li>`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-checkbox-marked-outline"></i>`;
        iwContent += `                            누적연료소모량`;
        iwContent += `                        </span>`;
        iwContent += `                        <span>${this.decimalPipe.transform(this.filterDist.transform(item.dtgOilUseAccumul),'0.0-1')} L</span>`;
        iwContent += `                    </li>`;
        iwContent += `                </ul>`;
        iwContent += `            </div>`;
        iwContent += `            <div class="col">`;
        iwContent += `                <ul class="list-group list-group-flush">`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-car"></i>`;
        iwContent += `                            단말번호`;
        iwContent += `                        </span>`;
        iwContent += `                        <span>${item.dtgUnitId}</span>`;
        iwContent += `                    </li>`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-checkbox-marked-outline"></i>`;
        iwContent += `                            속도`;
        iwContent += `                        </span>`;
        iwContent += `                        <span>${item.dtgSpeed} km/h</span>`;
        iwContent += `                    </li>`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-checkbox-marked-outline"></i>`;
        iwContent += `                            rpm`;
        iwContent += `                        </span>`;
        iwContent += `                        <span>${item.dtgRpm} rpm</span>`;
        iwContent += `                    </li>`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-checkbox-marked-outline"></i>`;
        iwContent += `                            전압`;
        iwContent += `                        </span>`;
        iwContent += `                        <span>${Number(item.dtgBatteryVolt * 0.1).toFixed(1)} V</span>`;
        iwContent += `                    </li>`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-checkbox-marked-outline"></i>`;
        iwContent += `                            온도1`;
        iwContent += `                        </span>`;
        iwContent += `                        <span>`;
        iwContent += `                            ${Number(item.dtgTemper1 * 0.1).toFixed(1)}`;
        iwContent += `                            <i class="mdi mdi-temperature-celsius"></i>`;
        iwContent += `                        </span>`;
        iwContent += `                    </li>`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-checkbox-marked-outline"></i>`;
        iwContent += `                            온도2`;
        iwContent += `                        </span>`;
        iwContent += `                        <span>`;
        iwContent += `                            ${Number(item.dtgTemper2 * 0.1).toFixed(1)}`;
        iwContent += `                            <i class="mdi mdi-temperature-celsius"></i>`;
        iwContent += `                        </span>`;
        iwContent += `                    </li>`;
        iwContent += `                </ul>`;
        iwContent += `            </div>`;
        iwContent += `        </div>`;
        iwContent += `    </div>`;
        iwContent += `</div>`;
        return iwContent;
    }

    // 운행이력 팝업
    clickShowDriveHis(event,carInfo:any){
        // console.log("clickShowDriveHis",carInfo);
        let modalRef = this.modalService.open(
            DtgCarLastTripListComponent
            ,{
                centered:true
                ,size: "xl"
                ,backdrop:"static"
                ,windowClass:"modal-dialog-drive-his"
                ,scrollable: false
            }
        );
        modalRef.componentInstance.selectedCarInput = carInfo;
        modalRef.result.then((resultModal) => {
            if(resultModal.result === "ok"){

            }
        });
    }

    // 지도의 교통정보 표시
    clickShowTraffic(){
        this.isShowTraffic = !this.isShowTraffic;
        if(this.isShowTraffic === true){
            this.mapService.showTraffic();
        }else{
            this.mapService.hideTraffic();
        }
    }

    // 지도의 자동 갱신
    clickMapAutoReload(){
        this.isMapAutoReload = !this.isMapAutoReload;
        if(this.isMapAutoReload === true){
            this.initMapAutoReload();
            interval(1000)
                .pipe(takeWhile(() => this.isContinue))
                .pipe(takeWhile(() => this.isMapAutoReload))
                .subscribe(() => this.queueMapAutoReload());
        }
    }

    // 지도 수동 갱신
    clickReloadMap(){
        let arg = {
            evtCode:"map.auto.reload.car"
        };
        this.fvmsMainCarService.subjCarFromMainMap.next(arg);
    }

    initMapAutoReload(){
        this.timeMapAutoReload = this.timeMapAutoReloadTerm;//3분후 리로드 실행
    }

    // 자동갱신 남은시간 출력
    getMapAutoReloadTimeDiff(){
        return new Date(this.timeMapAutoReload);
    }

    queueMapAutoReload(){
        this.timeMapAutoReload -= 1000;
        if(this.timeMapAutoReload <= 0){
            //run reload
            let arg = {
                evtCode:"map.auto.reload.car"
            };
            this.fvmsMainCarService.subjCarFromMainMap.next(arg);
            //시간연장
            this.initMapAutoReload();
        }
    }
}
